export default __webpack_public_path__ + "static/media/screens_mobile.af2e73b1.png";